import * as React from 'react';
import { SVGProps } from 'react';

const IconWellOpenSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 3.362V1h1v2.638L3.583 6 5 8.362V11H4V8.638L2.417 6 4 3.362ZM8 3.362V1H7v2.638L8.417 6 7 8.362V11h1V8.638L9.583 6 8 3.362Z"
    />
  </svg>
);
export default IconWellOpenSizeXs;
